import { useCallback } from 'react';

import { PopdownMenu } from '../../../shared/PopdownMenu';

const menuButtonBase = (type, faIcon, handleMenuAction, tile) => ({
  attrs: {
    className: `${type === 'copy' ? 'duplicate' : type}_title`,
    style: { width: '100%' },
  },
  faIcon,
  text: type.replace(/^\w/, character => character.toUpperCase()),
  clickEvent: e => {
    e.stopPropagation();
    handleMenuAction(tile, type, e);
  },
});

const renderMenuButtons = ({
  activeStatus,
  handleMenuAction,
  isUserSiteAdmin,
  tile,
}) => {
  const result = [
    menuButtonBase('copy', 'fa-regular fa-copy', handleMenuAction, tile),
    menuButtonBase('delete', 'fa-regular fa-trash-can', handleMenuAction, tile),
  ];
  const showUnscheduledButtonInStates = ['draft', 'plan'];
  const showUnscheduledButton =
    showUnscheduledButtonInStates.includes(activeStatus) &&
    (tile.planDate !== null || activeStatus === 'draft');

  if (isUserSiteAdmin && showUnscheduledButton) {
    result.push(
      menuButtonBase(
        'unscheduled',
        'fa-solid fa-left-long',
        handleMenuAction,
        tile,
      ),
    );
  }

  if (activeStatus === 'draft') {
    result.unshift(
      menuButtonBase('post', 'fa-solid fa-thumbtack', handleMenuAction, tile),
    );
  }

  return result;
};

const tileDropdownToggle = (tileId, toggle) => {
  if (toggle === 'show') {
    document
      .getElementById(`single-tile-${tileId}`)
      .children[0].classList.add('active_menu');
  } else {
    document
      .getElementById(`single-tile-${tileId}`)
      .children[0].classList.remove('active_menu');
  }
};

export const TilePopdownMenu = props => {
  const onShow = useCallback(() => tileDropdownToggle(props.tile.id, 'show'), [
    props.tile.id,
  ]);

  const onHide = useCallback(() => tileDropdownToggle(props.tile.id, 'hide'), [
    props.tile.id,
  ]);

  return (
    <PopdownMenu
      dropdownId={props.tile.id}
      afterShow={onShow}
      afterHide={onHide}
      menuProps={{
        className: 'tile_thumbnail_menu',
      }}
      menuElements={renderMenuButtons(props)}
    />
  );
};
